import React from "react"
import type { IContentItem } from "@kontent-ai/delivery-sdk"

import {
  GetTextMedia,
  GetTextMediaFromItem,
  TResolvedTextMedia,
} from "@/lib/kontent/components/getTextMedia"
import { CardResolver } from "@/components/ui/molecules/cards/card/Card.resolver"
import { ImageAndTextResolver } from "@/components/ui/organisms/image-and-text/ImageAndText.resolver"
import { ImageOverlapTextResolver } from "@/components/ui/organisms/image-overlap-text/ImageOverlapText.resolver"

type TTextMediaTemplateProps = {
  codename: string
  preview: boolean
  item?: IContentItem
  isInArticle?: boolean
}

const TextMediaTemplate = async ({
  codename,
  preview,
  item,
  isInArticle = false,
}: TTextMediaTemplateProps) => {
  const textMediaData = item
    ? await GetTextMediaFromItem(item, preview)
    : await GetTextMedia(codename, preview)

  switch (textMediaData.style) {
    case "Image and Text":
      return (
        <ImageAndTextResolver
          isInArticle={isInArticle}
          resolvedData={textMediaData}
        />
      )
    case "Image overlap + Text":
      return (
        <div className="relative">
          <ImageOverlapTextResolver
            isInArticle={isInArticle}
            resolvedData={textMediaData}
          />
        </div>
      )
    default: // "Card"
      return (
        <CardResolver isInArticle={isInArticle} resolvedData={textMediaData} />
      )
  }
}

TextMediaTemplate.displayName = "TextMediaTemplate"

type TTextMediaResolverProps = {
  data: TResolvedTextMedia
  isInArticle?: boolean
}

const TextMediaResolver = async ({
  data,
  isInArticle = false,
}: TTextMediaResolverProps) => {
  switch (data.style) {
    case "Image and Text":
      return (
        <ImageAndTextResolver isInArticle={isInArticle} resolvedData={data} />
      )
    case "Image overlap + Text":
      return (
        <div className="relative">
          <ImageOverlapTextResolver
            isInArticle={isInArticle}
            resolvedData={data}
          />
        </div>
      )
    default: // "Card"
      return <CardResolver isInArticle={isInArticle} resolvedData={data} />
  }
}
TextMediaResolver.displayName = "TextMediaResolver"

export {
  TextMediaTemplate,
  type TTextMediaTemplateProps,
  TextMediaResolver,
  type TTextMediaResolverProps,
}
